import { httpRequest } from '@/apis/request'

enum Apis {
  getLblMaterialColor = 'laobannian/colors',
}

/**
 * 获取老板良材质、颜色接口
 * @returns
 */
export async function fetchLblMaterialColor(factory_id: string) {
  return httpRequest.get(Apis.getLblMaterialColor, { factory_id })
}
